import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Link } from "react-router-dom/cjs/react-router-dom"
import { Card } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import IndustriesTable from "../../components/tables/IndustriesTable"
import MaterialIcon from "../../components/elements/MaterialIcon"
import { getIndustriesAction } from "../../actions/industriesActions"

class IndustryPage extends Component {

	componentDidMount() {
		this.props.getIndustriesAction({ pageSize: 15, sorted: null, filters: [], page: 1 })
	}

	render() {
		return (
			<div>
				<div className="top-actions-row">
					<Link to="industries/create" className="btn btn-primary btn-sm btn-roundet btn-dropshadow"><MaterialIcon icon="add" /><FormattedMessage id="buttons.new_industry" /></Link>
				</div>
				<Card className="fadeInLoadUp" >
					<Card.Body>
						<IndustriesTable />
					</Card.Body>
				</Card>
			</div>
		)
	}
}

IndustryPage.propTypes = {
	getIndustriesAction: PropTypes.func.isRequired,
	clients: PropTypes.shape({
		isLoading: PropTypes.bool,
		isExporting: PropTypes.bool,
		hasError: PropTypes.bool,
		filters: PropTypes.arrayOf(PropTypes.object),
		meta: PropTypes.shape({
			pagination: PropTypes.shape({
				current_page: PropTypes.number.isRequired
			})
		})
	}).isRequired
}

const mapStateToProps = (state) => ({
	clients: state.clients
})

export default connect(mapStateToProps, { getIndustriesAction })(IndustryPage)
